module.exports = __webpack_public_path__ + "static/media/landing-slide-1.58ec763d.png";